import PropTypes from 'prop-types'
import { Form, Formik } from 'formik'
import { LoaderButton } from 'components/molecules'

const propTypes = {
  consignmentInboundRequest : PropTypes.object,
  onSubmit                  : PropTypes.func
}

const defaultProps = {
  consignmentInboundRequest : {},
  onSubmit                  : () => {}
}

const ConsignmentInboundRequestCancelForm        = ({
  consignmentInboundRequest,
  onSubmit
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      id   : consignmentInboundRequest?.id,
      code : consignmentInboundRequest?.code
    }}
    onSubmit={ onSubmit }
  >
    <Form>
      <LoaderButton
        className='text-uppercase wider float-right'
        color='danger'
        type='submit'
        onClick={ onSubmit }
        text={ `Cancel Inbound Request ${consignmentInboundRequest?.code}` }
      />
    </Form>
  </Formik>
)
ConsignmentInboundRequestCancelForm.propTypes    = propTypes
ConsignmentInboundRequestCancelForm.defaultProps = defaultProps

export default ConsignmentInboundRequestCancelForm